import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toastr } from 'react-redux-toastr';
import PartnerListComponent from "./component";

const PartnerBlockListContainer = ({ getDataFromAPI }) => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [allPartners, setAllPartners] = useState([]);
  const [filteredPartners, setFilteredPartners] = useState([]);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize] = useState(20);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(true);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const fetchPartners = useCallback(async () => {
    if (!shouldFetch || loading) return;

    setLoading(true);
    try {
      const response = await new Promise((resolve, reject) => {
        getDataFromAPI(
          `/partner/api/v3/acc/blocked`,
          "GET",
          undefined,
          resolve,
          reject
        );
      });

      // Always replace the data when pageNumber is 0 (refresh)
      if (pageNumber === 0) {
        setAllPartners(response);
        setFilteredPartners(response);
      } else {
        setAllPartners(prev => [...prev, ...response]);
        setFilteredPartners(prev => [...prev, ...response]);
      }

      setHasMore(response.length === pageSize);
      setShouldFetch(false);
    } catch (err) {
      console.error("Partner API Error:", err);
      setShouldFetch(false);
    } finally {
      setLoading(false);
    }
  }, [pageNumber, loading, getDataFromAPI, pageSize, shouldFetch]);

  useEffect(() => {
    if (shouldFetch) {
      fetchPartners();
    }
  }, [fetchPartners, shouldFetch]);


  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchValue.trim() === "") {
        setFilteredPartners(allPartners);
      } else {
        const searchLower = searchValue.toLowerCase();
        const filtered = allPartners.filter(
          partner =>
            partner.ownerId?.toString().includes(searchLower) ||
            partner.cohortId?.toString().includes(searchLower)
        );
        setFilteredPartners(filtered);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [searchValue, allPartners]);

  const handleUnblock = async (partnerId) => {
    setLoading(true);
    try {
      const payload = {
        franchiseeId: parseInt(partnerId),
        block: false
      };

      await new Promise((resolve, reject) => {
        getDataFromAPI(
          "/partner/api/v3/acc/block-payout",
          "POST",
          payload,
          (response) => {
            setOpenSuccessDialog(true);
           
            setPageNumber(0);
            setShouldFetch(true);
            resolve(response);
          },
          (error) => {
            const errorMessage = error?.message || "Something went wrong while unblocking.";
            toastr.error(errorMessage);
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error("Error:", error);
      toast.error("Unblocking failed.");
    } finally {
      setLoading(false);
    }
  };


  const handleBlock = () => {
    navigate(`/home/configuration/partner/block-payout`)
  };




  const handleLoadMore = () => {
    if (hasMore && !loading) {
      setPageNumber(prev => prev + 1);
      setShouldFetch(true);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <PartnerListComponent
      partners={filteredPartners}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      onBlock={handleBlock}
      onUnblock={handleUnblock}
      onSelectPartner={setSelectedPartnerId}
      selectedPartnerId={selectedPartnerId}
      onLoadMore={handleLoadMore}
      hasMore={hasMore}
      loading={loading}
      onGoBack={handleGoBack}
      openSuccessDialog={openSuccessDialog}
      setOpenSuccessDialog={setOpenSuccessDialog}
    />
  );
};

export default connect(null, { getDataFromAPI })(PartnerBlockListContainer);